/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { useEffect, useState } from "react";
import { UAParser } from "ua-parser-js";
/**
 * Returns true if user agent is determined to be firefox
 */
export const useIsFirefox = (): boolean => {
	const [isFirefox, setIsFirefox] = useState(false);

	useEffect(() => {
		if (typeof window !== "undefined") {
			const parser = new UAParser();
			const browser = parser.getBrowser();
			const firefox = Boolean((browser.name || "").toLowerCase().includes("firefox"));
			setIsFirefox(firefox);
		}
	}, []);
	return isFirefox;
};
